import { apiRequest } from '@/utils/api-request';
import type { ArtifactListItem, PatchArtifactRequest } from '@/types/artifacts';

interface PatchArtifactResponse {
  success: boolean;
  message: string;
  artifact: ArtifactListItem;
}

export async function patchArtifact(
  orgId: string,
  artifactId: string,
  data: PatchArtifactRequest,
): Promise<PatchArtifactResponse> {
  const response = await apiRequest<PatchArtifactResponse>({
    url: `/api/v1/orgs/${orgId}/artifacts/${artifactId}?include_urls=false`,
    method: 'PATCH',
    target: 'workflow',
    body: data as Record<string, unknown>,
  });

  if (response.detail) throw new Error(response.detail);
  if (!response.data) throw new Error('Failed to update artifact');
  return response.data;
}
